const DEFAULT_OSS_HOST = 'yuanling-new.oss-cn-shanghai.aliyuncs.com';

const ossProxyPrefix = (): string => {
  const fromEnv = process.env.REACT_APP_OSS_PROXY_PREFIX;
  if (fromEnv != null && fromEnv !== '') {
    return fromEnv.replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'development') {
    return '/oss-cdn';
  }
  return '';
};

/** 将 OSS 直链转为同源路径，便于 dev/网关代理后 fetch 或 iframe 预览 */
export const toSameOriginOssUrl = (fileUrl: string): string => {
  const url = fileUrl?.trim() ?? '';
  if (!url) return '';
  try {
    const parsed = new URL(url);
    const prefix = ossProxyPrefix();
    if (prefix && parsed.hostname === DEFAULT_OSS_HOST) {
      return `${prefix}${parsed.pathname}${parsed.search}`;
    }
  } catch {
    return url;
  }
  return url;
};

export const fetchPdfObjectUrl = async (pdfUrl: string): Promise<string> => {
  const fetchUrl = toSameOriginOssUrl(pdfUrl) || pdfUrl;
  const response = await fetch(fetchUrl);
  if (!response.ok) {
    throw new Error(`PDF 加载失败 (${response.status})`);
  }
  const blob = await response.blob();
  const typed =
    blob.type === 'application/pdf'
      ? blob
      : new Blob([blob], { type: 'application/pdf' });
  return URL.createObjectURL(typed);
};

export const revokePdfObjectUrl = (objectUrl: string) => {
  if (objectUrl.startsWith('blob:')) {
    URL.revokeObjectURL(objectUrl);
  }
};
